import { useAppSelector } from '../../global/hooks';
import { selectActiveArrangementId, setBpm, setTimeSignature } from '../../store/appSlice';
import { loadSections } from '../../store/sectionsSlice';
import { Arrangement } from '../../types';
import { useDispatch } from 'react-redux';

export const useLoadArrangement = (arrangements: Arrangement[], onComplete: () => void) => {
	const dispatch = useDispatch();
	const activeArrangementId = useAppSelector(selectActiveArrangementId);
	if (activeArrangementId == null) return;
	const selectedArrangement = arrangements.find(a => a.id === activeArrangementId);
	return () => {
		if (selectedArrangement != null) {
			dispatch(setBpm(selectedArrangement.bpm));
			dispatch(setTimeSignature(selectedArrangement.timeSignature));
			dispatch(loadSections(selectedArrangement.sections));
			onComplete();
		}
	};
};

// export const useLoadArrangments = (): [Array<Arrangement>, DataState] => {
// 	const user = useAppSelector(selectUser);
// 	const [arrangements, setArranagements] = useState<Arrangement[]>([]);
// 	const [dataState, setDataState] = useState<DataState>('loaded');

// 	useEffect(() => {
// 		if (user?.id == null) return;
// 		(async () => {
// 			setDataState('loading');
// 			const response = await fetch(`/api/user/arrangements?userId=${Number(user.id)}`);
// 			const data: { arrangements: Arrangement[] } = await response.json();

// 			setArranagements(data.arrangements);
// 			setDataState('loaded');
// 		})();
// 	}, [user?.id]);

// 	return [arrangements, dataState];
// };
